import styled, { css } from 'styled-components';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';
import ContentfulImageRenderer from 'contentful/image_renderer';
import CallToAction from 'contentful/shared/call_to_action';
import Container from './shared/container';
import Grid from './shared/grid';
import FullScreenVideo from './full_screen_video';
import RTECompose from './RTE_compose';

const MediaSection = ({
  fields: {
    title,
    content,
    callToAction,
    image,
    videoUrl,
    mediaAlignment,
    backgroundColor,
    fullWidth = true,
  },
  ...rest
}) => {
  const hasContent = content || callToAction;

  return (
    <Section
      backgroundColor={backgroundColor}
      isFullWidth={fullWidth}
      hasContent={hasContent}
      {...rest}>
      <MediaGrid
        cols={hasContent ? 2 : 1}
        colGap={!fullWidth ? 0 : 40}
        rowGap={!fullWidth ? 0 : hasContent ? 40 : 24}
        isFullWidth={fullWidth}
        mediaLeft={mediaAlignment === 'left'}>
        {hasContent ? (
          <ContentWrapper
            mediaLeft={mediaAlignment === 'left'}
            hasPadding={!fullWidth}>
            {title && <Title className="mb-32">{title}</Title>}
            {content && <RTECompose content={content} fieldType="content" />}
            {callToAction && (
              <CallToAction
                className="mt-32"
                id={callToAction.sys.id}
                content={callToAction.fields}
                newTab
              />
            )}
          </ContentWrapper>
        ) : title ? (
          <Title className="mb-0">{title}</Title>
        ) : null}

        {image ? (
          <Image>
            <ContentfulImageRenderer image={image} />
          </Image>
        ) : videoUrl ? (
          <FullScreenVideo item={{ link: videoUrl }} isSquare={hasContent} />
        ) : null}
      </MediaGrid>
    </Section>
  );
};

const Title = styled.h2`
  font-size: ${toRem(32)};
  line-height: ${toRem(40)};
`;

const Section = styled(Container)`
  text-align: ${({ hasContent }) => (hasContent ? 'left' : 'center')};

  ${({ isFullWidth }) =>
    !isFullWidth &&
    css`
      padding: 0;
    `};
`;

const MediaGrid = styled(Grid)`
  align-items: center;

  ${({ isFullWidth }) =>
    !isFullWidth &&
    css`
      ${responsive('tabletSmall')} {
        grid-template-columns: ${({ mediaLeft }) =>
          mediaLeft ? '1fr 432px' : '432px 1fr'};
      }
    `}
`;

const Image = styled.div`
  text-align: center;
`;

const ContentWrapper = styled.div`
  ${({ hasPadding }) =>
    hasPadding &&
    css`
      padding: ${toRem(40)};
    `};

  ${responsive('tabletSmall')} {
    order: ${({ mediaLeft }) => (mediaLeft ? '1' : 'unset')};
  }
`;

export default MediaSection;
